import i18n from '@/i18n';

import { SOCIAL_MEDIA_LOGIN } from '../../constants';

const configFormBasic = () => {
    return {
        configFieldSelectCampaign: {
            trackBy: 'id',
            label: 'name',
            errorField: i18n.t('pageReturnPrize.nameCampaign'),
            valueSync: null,
            loading: false,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: []
        },
        configFieldSelectClient: {
            trackBy: 'id',
            label: 'name',
            errorField: i18n.t('managerForm.settingBasic.nameClient'),
            valueSync: null,
            loading: false,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: []
        },
        configFieldNameForm: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.nameForm'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['required', 'max255']
        },
        configFieldPublicPath: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.publicPath'),
            errorCustomMess: '',
            valueSync: '',
            length: 60,
            typesValidate: ['required', 'maxCustom', 'sub-domain']
        },

        configFieldLimitNumber: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.limitNumber'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max10']
        },
        configFieldRedirectURL: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.redirectURL'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255', 'url']
        },
        configFieldBlankEmailExpirationDate: {
            isNumber: true,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.blankEmailExpirationDate'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max10']
        },
        configFieldSendMailed: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.sendMailed'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255', 'email']
        },
        configFieldUrlPublicReservation: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.urlPublicReservation'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },
        configFieldUrlAfterPublicationEnd: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.urlAfterPublicationEnd'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },
        configFieldTag: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.tag'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },
        configFieldDateOfExpiry: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.dateOfExpiry'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },

        configFieldSelectPage: {
            trackBy: 'id',
            label: 'label',
            errorField: i18n.t('managerForm.settingPage.pageType'),
            valueSync: null,
            error: false,
            isRemove: true,
            isRequired: false,
            typesValidate: ['requiredSelect']
        },

        configFieldSelectTemplate: {
            trackBy: 'id',
            label: 'name',
            errorField: i18n.t('managerForm.temporarily.nameTemp'),
            valueSync: null,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: []
        },

        configFieldPublicationStartDateTime: {
            minuteStep: 1,
            placeholderTime: '',
            errorText: '',
            valueSync: '',
            error: false,
            typesValidate: ['dateTime'],
            errorField: i18n.t('managerForm.settingBasic.scheduleStart')
        },
        configFieldPublicationEndDateTime: {
            minuteStep: 1,
            placeholderTime: '',
            errorText: '',
            valueSync: '',
            error: false,
            typesValidate: ['dateTime'],
            errorField: i18n.t('managerForm.settingBasic.scheduleEnd')
        },

        configFieldBeforeThePeriod: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.beforeThePeriod'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['url']
        },
        configFieldAfterThePeriod: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingBasic.afterThePeriod'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['url']
        },

        validateArrayURL: [
            {
                configFieldUrlKey: {
                    isRequired: false,
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingBasic.keyUrlParam'),
                    errorCustomMess: '',
                    valueSync: '',
                    placeholder: 'name=abc&age=20',
                    typesValidate: ['required', 'max255']
                },
                configFieldUrlValue: {
                    isRequired: false,
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingBasic.valueUrlParam'),
                    errorCustomMess: '',
                    valueSync: '',
                    placeholder: '説明',
                    typesValidate: ['max255']
                }
            }
        ],

        validateArraySocial: SOCIAL_MEDIA_LOGIN.map((o) => {
            return {
                configField: {
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: o.name,
                    errorCustomMess: '',
                    valueSync: o?.value ? o.value : '',
                    typesValidate: ['max255']
                }
            };
        })
    };
};

const handleAddConfigURL = (validateArrayURL, url_parameters) => {
    validateArrayURL = url_parameters.map((o, idx) => {
        const varConfigKey = validateArrayURL[idx]?.configFieldUrlKey;
        const varConfigNote = validateArrayURL[idx]?.configFieldUrlValue;
        return {
            configFieldUrlKey: {
                isRequired: varConfigKey?.isRequired ?? false,
                error: varConfigKey?.error ?? false,
                errorField: varConfigKey?.errorField ?? i18n.t('managerForm.settingBasic.keyUrlParam'),
                errorCustomMess: varConfigKey?.errorCustomMess ?? '',
                valueSync: o.params ? o.params : '',
                placeholder: varConfigKey?.placeholder ?? 'name=abc&age=20',
                typesValidate: varConfigKey?.typesValidate ?? ['required', 'max255']
            },
            configFieldUrlValue: {
                isRequired: varConfigNote?.isRequired ?? false,
                error: varConfigNote?.error ?? false,
                errorField: varConfigNote?.errorField ?? i18n.t('managerForm.settingBasic.valueUrlParam'),
                errorCustomMess: varConfigNote?.errorCustomMess ?? '',
                valueSync: o.note ? o.note : '',
                placeholder: varConfigNote?.placeholder ?? '説明',
                typesValidate: varConfigNote?.typesValidate ?? ['max255']
            }
        };
    });

    return validateArrayURL;
};

const configModalListWorkflow = {
    title: i18n.t('managerForm.settingPage.pageType'),
    model: false,
    scrollable: true,
    hideFooter: false,
    size: '2xl'
};
export { configFormBasic, handleAddConfigURL, configModalListWorkflow };
